import { PatientDobChangeWarningMixin } from '../Mixins/PatientDobChangeWarningMixin.js';
export class PatientDemographics extends PatientDobChangeWarningMixin(HTMLElement)
{
    constructor() {
        super();
    }

    connectedCallback() {
        super.connectedCallback();
        this.init();
    }

    disconnectedCallback() {
        window.removeEventListener('popstate', this._boundOnPopState);
    }

    init() {
        this._boundOnPopState = this.onPopState.bind(this);
        window.addEventListener('popstate', this._boundOnPopState);
    }

    onPopState(event) {
        event.stopImmediatePropagation();
        const backBtn = this.querySelector('.closeLevel');
        if (backBtn) {
            backBtn.click();
        }
    }

}

customElements.define('patient-demographics', PatientDemographics);